import React, { useContext } from "react";
import ReactModal from "react-modal";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

import Plyr from "plyr-react";
import "plyr-react/plyr.css";

function MediaPlayer() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    content: {
      borderRadius: "12px",
      flex:
        appState.mediaPlayerOptions.mediaType === "audio"
          ? "0 0 484px"
          : "0 0 984px",
      overflow: "hidden",
    },
  };

  const plyrProps = {
    source: {
      type: "audio",
      sources: [
        {
          src: `storage/${appState.livre.isbn}/${appState.mediaPlayerOptions.mediaSrc}.mp3`,
          type: "audio/mp3",
        },
      ],
    }, // https://github.com/sampotts/plyr#the-source-setter
    options: {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        // "mute",
        // "volume",
        // "captions",
        // "settings",
        // "pip",
        // "airplay",
        // "fullscreen",
      ],
      autoplay: true,
    }, // https://github.com/sampotts/plyr#options
  };

  function closeModal() {
    appDispatch({ type: "CLOSE_MEDIA_PLAYER" });
  }

  ReactModal.setAppElement("#root");

  return (
    <ReactModal
      isOpen={appState.mediaPlayerIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Lecteur multimédia"
      className={`modal-window media-player`}
    >
      <button onClick={closeModal} className="modal-window__fermer">
        <span className="visually-hidden">Fermer</span>
      </button>
      <div
        className={`modal-window__container modal-window__container--${appState.mediaPlayerOptions.mediaType}`}
      >
        {appState.mediaPlayerOptions.mediaType === "audio" ? (
          <Plyr {...plyrProps} />
        ) : (
          <div class="ratio ratio-70">
            <iframe
              src={`https://player.vimeo.com/video/${appState.mediaPlayerOptions.mediaSrc}`}
              allowfullscreen
            ></iframe>
          </div>
        )}
      </div>
    </ReactModal>
  );
}

export default MediaPlayer;
